import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSettingParams } from '../../../common/filterCompany/useSettingParams'
import { UseI18n } from '../../../common/hooks/useI18n'
import { Panel } from '../../../common/panel'
import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../common/selectCurrencyUnit/useFormatCurrency'
import { selectPeriod } from '../../common/period/slice'
import { PortfolioOverviewContent } from './Content'
import {
  resetStorePortfolioOverview,
  selectAnalyse,
  selectLoading,
  selectVersus,
} from './store/slice'
import { exportPortfolioOverview, getPortfolioOverview } from './store/thunk'

export const PortfolioOverview = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const settingParams = useSettingParams()
  const period = useSelector(selectPeriod)
  const { currency } = useFormatCurrency(SCREEN.PORTFOLIO_INSIGHTS)
  const analyse = useSelector(selectAnalyse)
  const versus = useSelector(selectVersus)
  const isLoading = useSelector(selectLoading())
  const label = UseI18n('portfolio.summary.PORTFOLIO_OVERVIEW')

  useEffect(() => {
    if (!settingParams) return
    dispatch(
      getPortfolioOverview({
        ...settingParams,
        currency,
        analyseType: analyse,
        versusType: versus,
      }),
    )
  }, [settingParams, analyse, versus, currency, locale])

  useEffect(() => {
    return () => dispatch(resetStorePortfolioOverview())
  }, [])

  const downloadCsv = {
    downloadFunc: () =>
      exportPortfolioOverview({
        ...settingParams,
        currency,
        timeFrequency: period,
        analyseType: analyse,
        versusType: versus,
      }),
    disabled: !settingParams || isLoading,
  }

  const downloadJpgParams = {
    arrName: [label],
    domId: 'PORTFOLIO_OVERVIEW_TABLE_ID',
    titleJpg: label,
    disabled: !settingParams || isLoading,
  }

  return (
    <Panel
      label={label}
      isI18n={false}
      headerStyle={{ textTransform: 'capitalize' }}
      downloadCsv={downloadCsv}
      downloadJpgParams={downloadJpgParams}
    >
      <PortfolioOverviewContent />
    </Panel>
  )
}
